import { productTypeNames } from "../Constants";
import { requestLoadingByResvTypeSelector, resvTypeByLid } from "../Selectors";
import { TReservationResult } from "../store/types";
import useAppSelector from "./useAppSelector";

export const usePreFetch = (resvTypeId: number) => {
    const reservationResult = useAppSelector(state => state.reservationResult);
    const reservationTypeResult: TReservationResult = reservationResult[resvTypeId];
    const preFetchResult = reservationTypeResult?.preFetchResult;
    const reservationType = useAppSelector(state => resvTypeByLid(state, resvTypeId));
    const preFetchLoading = useAppSelector(state =>
        requestLoadingByResvTypeSelector(state, "preFetchReservationTypeResults", resvTypeId)
    );

    let allowPreFetch = false;

    // Only allow pre-fetch for accommodation products for now.
    if (reservationType?.type === productTypeNames.ACCOMMODATION) {
        allowPreFetch = true;
    }

    return { allowPreFetch, preFetchResult, preFetchLoading };
};
